import React, { useState } from 'react';
import { SimpleTooltip } from 'lib/components/Tooltip/SimpleTooltip';

function KPITooltip({ children, text }) {
    const [tooltipActive, setTooltipActive] = useState(false);
    const [tooltipText, setTooltipText] = useState(null);
    const [clientX, setClientX] = useState(null);
    const [clientY, setClientY] = useState(null);

    const handleMouseOver = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const { left, width, y } = rect;
        setClientX(left + width / 4);
        setClientY(y);
        setTooltipText(text);
        setTooltipActive(true);
    };

    const handleMouseOut = () => {
        setTooltipActive(false);
        setTooltipText(null);
    };

    children.props.onMouseOver = handleMouseOver;
    children.props.onMouseLeave = handleMouseOut;

    return (
        <>
            {tooltipActive && (
                <SimpleTooltip active={tooltipActive} left={clientX} top={clientY}>
                    {tooltipText}
                </SimpleTooltip>
            )}
            {children}
        </>
    );
}

export default KPITooltip;
